import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const LinkedHandbookIcon = React.forwardRef(({ color, height, viewBox, width, ...rest }, ref) => {
    return (
        <SvgIcon ref={ref} width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fillRule="evenodd"
                fill={color}
                d="M18.49,1.7v10.05c-.26.16-.51.36-.74.58l-.82.82c-.23.23-.39.5-.49.79V2.72H3.59c-.41,0-.8.16-1.09.45s-.45.68-.45,1.09v12.16c.48-.23,1-.35,1.54-.35h10.4l-.98.98-.03.02c-.3.31-.55.67-.75,1.05H3.59c-.41,0-.8.16-1.09.45-.29.29-.45.68-.45,1.09s.16.8.45,1.09c.29.29.68.45,1.09.45h8.29c.19.77.59,1.48,1.16,2.05H3.59c-.95,0-1.87-.38-2.54-1.05-.67-.68-1.05-1.59-1.05-2.54V4.26c0-.95.38-1.87,1.05-2.54.68-.67,1.59-1.05,2.54-1.05h13.87c.57,0,1.03.46,1.03,1.03Z"
            />
            <g>
                <path
                    fill={color}
                    d="M23.07,13.24c-.59-.59-1.38-.93-2.22-.93-.84-.01-1.63.31-2.24.89l-.82.82c-.32.32-.32.84,0,1.17.16.16.36.24.58.24,0,0,0,0,0,0,.22,0,.43-.09.58-.24l.8-.8c.29-.28.66-.43,1.06-.43,0,0,0,0,.01,0,.4,0,.78.16,1.07.45.29.29.45.67.45,1.07,0,.4-.15.79-.42,1.07l-1.41,1.41c-.16.16-.34.28-.55.35-.21.08-.42.11-.64.09-.22-.02-.43-.08-.63-.18s-.36-.25-.49-.43c-.13-.18-.32-.29-.54-.32-.22-.03-.44.02-.61.16-.36.27-.44.79-.17,1.16.28.37.62.67,1.02.89.4.22.84.35,1.3.38.08,0,.15,0,.23,0,.38,0,.75-.07,1.11-.2.43-.16.81-.41,1.14-.73l1.42-1.43c.58-.6.9-1.4.89-2.24,0-.84-.34-1.63-.93-2.22Z"
                />
                <path
                    fill={color}
                    d="M18.6,20.21c-.22,0-.43.09-.58.24l-.8.8c-.29.28-.67.43-1.08.43-.4,0-.78-.16-1.07-.45-.29-.29-.45-.67-.45-1.07,0-.4.15-.79.42-1.07l1.41-1.41c.16-.16.34-.28.55-.35.21-.08.42-.11.64-.09.22.02.43.08.63.18.19.11.36.25.49.43.13.18.32.29.54.32.22.03.44-.02.61-.16.36-.27.44-.79.17-1.15-.28-.37-.62-.67-1.02-.89-.4-.22-.84-.35-1.3-.38-.46-.03-.91.03-1.34.19-.42.16-.82.41-1.14.73l-1.42,1.43c-.58.6-.9,1.4-.89,2.24,0,.84.34,1.63.93,2.22.59.59,1.38.93,2.22.93,0,0,.02,0,.03,0,.83,0,1.61-.32,2.21-.89l.82-.82c.32-.32.32-.85,0-1.17-.16-.16-.36-.24-.58-.24Z"
                />
            </g>
        </SvgIcon>
    );
});

LinkedHandbookIcon.displayName = 'LinkedHandbookIcon';

LinkedHandbookIcon.propTypes = {
    color: string,
    height: string,
    viewBox: string,
    width: string,
};

LinkedHandbookIcon.defaultProps = {
    color: MIGRATED_COLORS.black,
    height: '24px',
    viewBox: '0 0 24 24',
    width: '24px',
};

export default LinkedHandbookIcon;
